import { Button, Divider, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesAction,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import Url from "../../apiCall/UrlConfig";
//////Redux
const VideoDemo = (props) => {
  const navigation = useNavigate();
  const { backtolabel } = useParams();

  const seeDemoDone = async () => {
    let url = Url.saveSeeDemo;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    navigation("/examStudent");
  };

  return (
    <div>
      <Divider>مشاهده دموی تشخیص پوسیدگی</Divider>
      {backtolabel && (
        <Button onClick={() => navigation("/dentistLabeling")}>بازگشت</Button>
      )}
      <div className="text-center">
        ابتدا باید ویدیو را کامل ببینید تا وارد اپلیکیشن تشخیص پوسیدگی شوید
      </div>

      <div className="text-center">
        <video onEnded={seeDemoDone} className="videoDemo" controls>
          <source src="/video/demo.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  );
};
const actionCreators = Object.assign(
  {},
  {
    CallCoreServicesAction,
    OfflineCoreServices,
    CallCoreServicesActionWithToken,
  }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoDemo);
